import { call, put, takeLatest } from "redux-saga/effects";
import { getProjectManagementDetails } from "../http/requests/project-management";
import {
  setVtrackLoader
} from "../redux/actions";
import { ProjectManagementType, setExportProjectManagementData, setProjectManagementData } from "../redux/actions/project-management";

function* workerProjectManagementSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    const projectManagementDetails = yield call(
      getProjectManagementDetails,
      payload.projectId,
      payload.pageNo,
      payload.pageSize,
      payload.sortDir,
      payload.sortBy,
      payload.searchData,
     payload.billStatus,
     payload.expiredAllocations
    );
    if(payload.isExport){
      
      yield put(setExportProjectManagementData(projectManagementDetails));
     }
      yield put(setProjectManagementData({ ...projectManagementDetails, projectId: payload.projectId }));

    yield put(setVtrackLoader(false));
  } catch (err) {
    console.log(err);
    yield put(setVtrackLoader(false));
  }
};

export function* projectManagementSaga() {
  yield takeLatest(
    ProjectManagementType.GET_PROJECT_MANAGEMENT_DATA,
    workerProjectManagementSaga
  );
};
